import { MappingConfig } from '../../base/models/mapping-config';

/**
 * Mapping configuration corresponding to a user mapping
 */
export class MappingUserConfig extends MappingConfig {}
